module.exports = __webpack_public_path__ + "static/media/battery_eng_03.e01f6be8.png";